import * as organization from './organization'
import * as auth from './auth'
import * as channel from './channel'
import * as storage from './storage'
import * as user from './user'
import * as group from './group'
import * as share from './share'
import * as tag from './tag'
import * as division from './division'

const baseURL = 'https://api-stage.yessspad.com'

export default {
  baseURL,
  auth,
  organization,
  storage,
  channel,
  user,
  group,
  share,
  tag,
  division
}



// WEBPACK FOOTER //
// ./src/services/api/index.js